import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { FileText, LogOut, ExternalLink } from "lucide-react";
import { ADMIN_SESSION_KEY } from "../../config/adminConfig";
import styles from "./AdminLayout.module.css";

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem(ADMIN_SESSION_KEY);
    navigate("/admin/login");
  };

  return (
    <div className={styles.shell}>
      <aside className={styles.sidebar}>
        <Link to="/admin/blogs" className={styles.brand}>
          <span>ARABELLA</span>
          <small>Blog Admin</small>
        </Link>

        <nav className={styles.nav}>
          <NavLink
            to="/admin/blogs"
            className={({ isActive }) =>
              isActive ? `${styles.navLink} ${styles.active}` : styles.navLink
            }
          >
            <FileText size={18} />
            Blogs
          </NavLink>
        </nav>

        <div className={styles.sidebarFooter}>
          <Link to="/blogs" className={styles.secondaryLink} target="_blank" rel="noreferrer">
            <ExternalLink size={16} />
            View website
          </Link>
          <button type="button" className={styles.logoutBtn} onClick={handleLogout}>
            <LogOut size={16} />
            Log out
          </button>
        </div>
      </aside>

      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
